import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import type { RoutingStrategy } from '@/components/shipment/form/utils/shipment-form-routing';
import {
  buildRoutingCoordinates,
  type LatLng,
} from '@/components/shipment/form/utils/build-routing-coordinates';
import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore';

export function useShipmentFormRouting(options: {
  strategy: MaybeRefOrGetter<RoutingStrategy>;
  stops: MaybeRefOrGetter<readonly ShipmentFormStopRow[]>;
  trackerPosition: MaybeRefOrGetter<LatLng | null>;
}) {
  const routingCoordinates = computed(() =>
    buildRoutingCoordinates({
      strategy: toValue(options.strategy),
      stops: toValue(options.stops),
      trackerPosition: toValue(options.trackerPosition),
    }),
  );

  const canComputeRoute = computed(() => {
    const coords = routingCoordinates.value;
    return coords != null && coords.length >= 2;
  });

  return {
    routingCoordinates,
    canComputeRoute,
  };
}
